














import { Component, Vue } from "vue-property-decorator";
import CustomTable from "@/components/table.vue";
import HistoryApi from "@/api/admin/history";
import { HistoryModel, PaginationModel, WalletModel } from "@/api/types";
import WalletApi from "@/api/admin/wallet";

@Component({
  components: {
    CustomTable,
  },
})
export default class History extends Vue {
  data: HistoryModel[] = [];
  pagination: PaginationModel & { total?: number } = {
    current: 1,
    pageSize: 10,
    total: 0,
  };
  wallet: WalletModel = {};
  visible = false;
  modalLoading = false;

  datum: HistoryModel = {};

  columns = [
    {
      width: 200,
      title: "id",
      dataIndex: "id",
    },
    {
      title: "수량",
      dataIndex: "amount",
      scopedSlots: { customRender: "amount" },
    },
    {
      title: "내용",
      dataIndex: "description",
      scopedSlots: { customRender: "description" },
    },
    {
      title: "txId",
      dataIndex: "txId",
      scopedSlots: { customRender: "txId" },
    },
    {
      width: 200,
      align: "right",
      title: "발생일",
      dataIndex: "createdTime",
      scopedSlots: { customRender: "createdTime" },
    },
  ];

  moveOn(page: any) {
    this.pagination = page;
    this.load();
  }

  search() {
    this.pagination = {
      ...this.pagination,
      current: 1,
    };
    this.load();
  }

  showModal() {
    this.visible = true;
  }

  async handleOk() {
    this.modalLoading = true;

    this.load();
    this.modalLoading = false;
    this.visible = false;
  }

  handleCancel() {
    this.visible = false;
  }

  mounted() {
    this.load();
  }

  async load() {
    const { id } = this.$route.query as { id: string };
    this.wallet = await WalletApi.single(id);
    const result = await HistoryApi.list(id, this.pagination);
    console.log(result);

    this.data = [...result.data];
    this.pagination.total = result.totalCount;
  }
}
